<div class="team-publish-container">
  <div class="row info-panel">
    <div class="row">
      <div class="col-xs-12">
        <div class="row form-group">
          <label class="control-label col-md-3">{{locale.LABEL_ARTIFACT_METADATA}}</label>
          <table class="wm-table" *ngIf="artifactPublishDetails.metadataObjs.length">
            <colgroup>
              <col width="50"/>
              <col width="50"/>
            </colgroup>
            <tbody>
            <tr *ngFor="let metadata of artifactPublishDetails.metadataObjs">
              <td class="word-break"><span>{{metadata.key}}</span></td>
              <td class="word-break">{{metadata.value}}</td>
            </tr>
            </tbody>
          </table>
          <label class="publish-text" *ngIf="!artifactPublishDetails.metadataObjs.length">{{locale.LABEL_ARTIFACT_NO_METADATA}}</label>
        </div>
        <div class="row form-group">
          <label class="control-label col-md-3">{{locale.LABEL_ARTIFACT_TAG}}</label>
          <div class="app-chips col-md-7">
            <div class="tag-field col-md-12">
              <div><input type="text" [(ngModel)]="artifactPublishDetails.tag" class="form-control" name="tag" (keypress)="onTagKeyPress($event)"></div>
              <button class="btn btn-primary add-button provider-btn wm-tile-thumbnail-ctr" (click)="addTag()" title="{{locale.LABEL_ARTIFACT_ADD_TAG}}">
                <i class="wi wi-add"></i>
              </button>
            </div>
            <div class="row added-tags">
              <li *ngFor="let tag of artifactPublishDetails.tags; let index = index;" name="wm-prefab">
                <span>{{tag}}</span>
                <span class="delete-tag" (click)="artifactPublishDetails.tags.splice(index,1)" title="{{locale.LABEL_ARTIFACT_DELETE_TAG}}">
                                    <i class="wi wi-close"></i>
                                </span>
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
